import React from 'react';
import { Bar } from '@ant-design/plots';
import { formatCurrency } from '../../../utils/formatCurrency';

const BarChartAdsOrigins = () => {
    // Dados fictícios
    const data = [
        { name: 'Google Ads', value: 1200 },
        { name: 'Facebook Ads', value: 800 },
        { name: 'Instagram Ads', value: 600 },
        { name: 'LinkedIn Ads', value: 400 },
    ];

    const config = {
        data: data,
        xField: 'value',
        yField: 'name',
        seriesField: 'name',
        legend: false,
        label: {
            position: 'middle',
            style: {
                fill: '#ffffff',
            },
            formatter: (datum) => `${formatCurrency(datum.value)}`,
        },
        tooltip: {
            formatter: (datum) => {
                return {
                    name: datum.name,
                    value: formatCurrency(datum.value),
                };
            },
        },
        xAxis: {
            label: {
                formatter: (value) => formatCurrency(value),
            },
        },
        animation: false,
        height: 250,
    };

    return <Bar {...config} />;
};

export default BarChartAdsOrigins;